import bem from 'utils/bem';

export const popperBlock = bem('popper');
export const popperRadioBlock = bem('popper-radio');
export const popperTriggerBlock = bem('popper-trigger');
export const popperToggleBlock = bem('popper-toggle');
